//core
// import React, { useState,useEffect,useContext } from 'react';
import React from 'react';
import moment from 'moment';
//Dashboard PRO
// import Button from "components/CustomButtons/Button.jsx";
import Button from '@material-ui/core/Button';
//component
import OSS from 'ali-oss';
//img
import idcardfront from "assets/img/idcardfront.png";
import idcardback from "assets/img/idcardback.png";
import { getOssClient } from 'shared/oss-conf';

const baseUrl = 'http://v2cs-oss.oss-cn-beijing.aliyuncs.com/';

export default function UploadOss(props) {
  const inputRef = React.createRef();

  const handleClick = () => {
    inputRef.current.click();
  }

  const handleChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) {//没有文件的时候不往下执行
      return;
    }
    const originName = file.name;

    const fileNameArr = originName.split('.');
    if (fileNameArr.length > 2) { // 有两个以上元素说明文件名中包含.
      props.openSnackbar('文件名不能包含特殊字符，请修改后上传', 'warning');
      return;
    }

    const regEn = /^[\u4e00-\u9fa5_\-()（）a-zA-Z0-9_]{1,30}$/;
    if (!regEn.test(fileNameArr[0])) {
      props.openSnackbar('文件名不能包含特殊字符且小于30个字符，请修改后上传', 'warning');
      return;
    }
    let fileName = moment().format('YYYY/MM/DD/HH/mm/ss/SSS/') + file.name;
    reader.readAsArrayBuffer(file);
    reader.onload = function (event) {
      let buffer = new OSS.Buffer(event.target.result);
      getOssClient().then(client => {
        client.put(fileName, buffer).then(res => {
          props.uploadSuccess(res);
        }, err => {
          props.uploadError(err);
        })
      })
    }
  }

  const imgSrc = () => {
    const defaultImgSrc = props.type === 'idcardfront' ? idcardfront : idcardback;
    return props.fileList ? (baseUrl + props.fileList) : defaultImgSrc;
  }

  return (
    <React.Fragment>
      <div style={{ ...props.style }} className={props.className + " fileinput text-center"}>
        <input id={props.type + 'Upload'}
          ref={inputRef} type='file'
          onChange={handleChange} />
        <img style={{ width: '160px' }} alt='' src={imgSrc()} />
        <Button className='upload-btn' onClick={() => handleClick()}>
          {props.btnText ? props.btnText : '选择文件'}
        </Button>
      </div>
    </React.Fragment>
  )
}